"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = void 0;
const generic_entity_1 = require("../../../../abstracts/generic-entity");
/**
 * A generic `Role` client.
 * Use this to create or list roles
 */
class Roles extends generic_entity_1.Entity {
    constructor(parentEntity, debug) {
        super(parentEntity, debug);
    }
    /**
     * This will create a new role
     * @param args `CreateRoleRequestDto`
     * @returns `RoleResponseDto`
     */
    async create(data) {
        return (await this.getHttpClient().post('/role', data, { headers: this.getHeaders() })).data;
    }
    /**
     * List all roles
     * @returns List of `RoleResponseDto`
     */
    async list() {
        return (await this.getHttpClient().get('/role', { headers: this.getHeaders() })).data;
    }
}
exports.Roles = Roles;
